import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import { resetUpdateDsrOutcome, updateDsr } from '../actions/dsr-actions'
import PageLoader from '../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal'


function DsrCardUnpublishModal({ modalTransferPayload, handleCloseModal, updateDsr, updateDsrOutcome, resetUpdateDsrOutcome }) {

  // UX Management
  const [showLoader, setShowLoader] = useState(false)
  const { dsrId, dsrTitle } = modalTransferPayload || {}

  useEffect(() => {
    if (updateDsrOutcome) {
      const { updateDsrStatus } = updateDsrOutcome || {};

      if (updateDsrStatus) {
        setShowLoader(false)
        resetUpdateDsrOutcome()
        handleCloseModal()
      }
    }
  }, [updateDsrOutcome]);

  const handleClickUnpublishButton = () => {
    setShowLoader(true);
    updateDsr({ dsrId, status: 'reverted-draft', sourceEvent: "revert-dsr-to-draft" })
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {

      return (
        <Flex justify='flex-start' px='1.5em' mt='1em' w='100%'>
          <Box w='100%'>

            <Box w="100%" my="1em" color='brandDark.500'>
              <Box fontSize='0.875em'>
                It will return to its draft state, and all content will remain as it is. However, members will be unable to view the Room until it is published again.
              </Box>

              <Box fontSize='0.875em' mt='0.875em'>
                Proceed?
              </Box>
            </Box>

            <Flex w='100%' mt='1em'>
              <Flex my='0.625em' justify='flex-end' w='100%'>
                <LaunchdeckButton bg='gray.700' color='white' onClick={() => handleClickUnpublishButton()} label='Unpublish' />
              </Flex>
            </Flex>
          </Box>
        </Flex>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={`You are about to unpublish ${dsrTitle || "this Room"}`}
      handleCloseModal={handleCloseModal}
      showModal={true}
      maxW='45em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    updateDsrOutcome: state.updateDsrOutcome.results.data
  };
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr,
      resetUpdateDsrOutcome,
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrCardUnpublishModal));
